export const ticketStatus = {
    invalid: "invalid_qr",
    claimed: "claimed_qr",
    expired: "expired_qr",
    locked: "locked_qr",
    claimable: "claimable_qr",
};
export var TicketStatus;
(function (TicketStatus) {
    TicketStatus["Invalid"] = "invalid_qr";
    TicketStatus["Claimed"] = "claimed_qr";
    TicketStatus["Expired"] = "expired_qr";
    TicketStatus["Locked"] = "locked_qr";
    TicketStatus["Claimable"] = "claimable_qr";
})(TicketStatus || (TicketStatus = {}));
//# sourceMappingURL=tickets.constants.js.map